/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const deleteApiAdminDevtoolsOnboardingStepStepNameParams = zod.object({
  "stepName": zod.enum(['BusinessVerificationSubmitted', 'BusinessVerified', 'AstraAuthorized', 'BankAccountLinked', 'AccountFundingInitiated', 'AccountFunded', 'FirstOppCreated', 'TalentInvited', 'FirstPayoutCompleted'])
})

export const postApiAdminDevtoolsAdjustBalanceBody = zod.object({
  "amount": zod.number(),
  "type": zod.enum(['Credit', 'Debit'])
})

export const postApiAdminDevtoolsAdjustBalanceResponse = zod.object({
  "availableBalance": zod.number(),
  "pendingDeposits": zod.number()
})

export const getApiAdminDevtoolsFundingAccountBalanceCheckResponse = zod.object({
  "enabled": zod.boolean()
})

export const putApiAdminDevtoolsFundingAccountBalanceCheckBody = zod.object({
  "enabled": zod.boolean()
})

export const putApiAdminDevtoolsFundingAccountBalanceCheckResponse = zod.object({
  "enabled": zod.boolean()
})

export const postApiAdminDevtoolsBatchProcessSimulationBody = zod.object({
  "itemCount": zod.number(),
  "minDelayMilliseconds": zod.number(),
  "maxDelayMilliseconds": zod.number(),
  "delayPercentiles": zod.object({
  "p50Milliseconds": zod.number(),
  "p75Milliseconds": zod.number(),
  "p90Milliseconds": zod.number(),
  "p95Milliseconds": zod.number()
}).optional(),
  "failCount": zod.number(),
  "area": zod.enum(['Fsm', 'PayoutRequest']),
  "name": zod.string().nullish(),
  "rateLimit": zod.object({
  "waitTimeoutMilliseconds": zod.number(),
  "useInProcessRateLimiter": zod.boolean(),
  "window": zod.object({
  "permitLimit": zod.number(),
  "windowMilliseconds": zod.number()
}).optional(),
  "concurrency": zod.object({
  "permitLimit": zod.number(),
  "leaseTimeoutMilliseconds": zod.number()
}).optional(),
  "tokenBucket": zod.object({
  "tokenLimit": zod.number(),
  "tokensPerPeriod": zod.number(),
  "replenishmentPeriodMilliseconds": zod.number()
}).optional()
}).optional()
})

export const postApiAdminDevtoolsBatchProcessSimulationResponse = zod.string().uuid()

export const postApiAdminDevtoolsRecycleJobsHostResponse = zod.object({
  "requestId": zod.string().uuid()
})

export const postApiAdminDevtoolsJobsJobTriggerParams = zod.object({
  "job": zod.enum(['AddressGeocodeBackfill', 'AstraAccountStatusPoll', 'AstraTokenRefresh', 'AutoTopUp', 'BalanceTransferReconciliation', 'BatchProcessResume', 'DepositPlanning', 'DisbursementRun', 'EmailVerificationPurge', 'FailedDepositReconciliation', 'FsmCompletedWorkRetry', 'FsmSyncPast24HoursEveryHour', 'FsmSyncPast7DaysEveryDay', 'FsmSyncPastHourEvery5Minutes', 'FsmTechInvitation', 'FsmTechSync', 'IdentityVerificationAstraBackfill', 'IdentityVerificationStatusRecovery', 'IdentityVerificationSuspensionRecheck', 'LowBalanceCheck', 'OrganizationAddressBackfill', 'OrglessAccountDetection', 'OverduePayoutExpiration', 'PaymentReconciliation', 'PendingPayoutDigest', 'RealTimePaymentEligibilityRecheck', 'ReportExportFileCleanup', 'RosterEmailCollisionScan', 'ScheduledDepositInitiation', 'ScheduledPayoutDigest', 'SignupPurge', 'StaleConsumerGroupPrune', 'StrandedPaymentRecovery', 'StreamRecovery', 'WeeklyEarningsDigest'])
})

export const getApiAdminDevtoolsSuperiorPumpEnrollmentOpportunitiesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "title": zod.string(),
  "referenceLabels": zod.array(zod.string())
})
export const getApiAdminDevtoolsSuperiorPumpEnrollmentOpportunitiesResponse = zod.array(getApiAdminDevtoolsSuperiorPumpEnrollmentOpportunitiesResponseItem)

export const getApiAdminDevtoolsSuperiorPumpEnrollmentResponseItem = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "opportunityTitle": zod.string(),
  "voucherRecipientEmail": zod.string(),
  "pumpModelNumber": zod.string(),
  "serialReferenceLabel": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})
export const getApiAdminDevtoolsSuperiorPumpEnrollmentResponse = zod.array(getApiAdminDevtoolsSuperiorPumpEnrollmentResponseItem)

export const getApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdParams = zod.object({
  "opportunityId": zod.string().uuid()
})

export const getApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "opportunityTitle": zod.string(),
  "voucherRecipientEmail": zod.string(),
  "pumpModelNumber": zod.string(),
  "serialReferenceLabel": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdParams = zod.object({
  "opportunityId": zod.string().uuid()
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdBody = zod.object({
  "voucherRecipientEmail": zod.string(),
  "pumpModelNumber": zod.string(),
  "serialReferenceLabel": zod.string()
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "opportunityTitle": zod.string(),
  "voucherRecipientEmail": zod.string(),
  "pumpModelNumber": zod.string(),
  "serialReferenceLabel": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})

export const deleteApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdParams = zod.object({
  "opportunityId": zod.string().uuid()
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdActiveParams = zod.object({
  "opportunityId": zod.string().uuid()
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdActiveBody = zod.object({
  "isActive": zod.boolean()
})

export const putApiAdminDevtoolsSuperiorPumpEnrollmentOpportunityIdActiveResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "opportunityTitle": zod.string(),
  "voucherRecipientEmail": zod.string(),
  "pumpModelNumber": zod.string(),
  "serialReferenceLabel": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})

export const getApiAdminDevtoolsBusinessVerificationReviewResponse = zod.object({
  "attemptCount": zod.number(),
  "paidAttemptCount": zod.number(),
  "orphanedBusinessProfileCount": zod.number(),
  "firstAttemptedAt": zod.string().datetime({}).nullish(),
  "lastAttemptedAt": zod.string().datetime({}).nullish(),
  "verificationStatus": zod.enum(['NotStarted', 'Pending', 'UnderReview', 'Approved', 'Rejected', 'Suspended']).optional(),
  "requesters": zod.array(zod.object({
  "requestedByUserId": zod.string().uuid(),
  "isSharedWithAnotherOrganization": zod.boolean()
})),
  "ipAddresses": zod.array(zod.object({
  "ipAddress": zod.string(),
  "isSharedWithAnotherOrganization": zod.boolean()
}))
})

export const postApiAdminDevtoolsBusinessVerificationAttemptsClearResponse = zod.number()

export const postApiAdminDevtoolsBusinessVerificationAttemptsUserRequestedByUserIdClearParams = zod.object({
  "requestedByUserId": zod.string().uuid()
})

export const postApiAdminDevtoolsBusinessVerificationAttemptsUserRequestedByUserIdClearResponse = zod.number()

export const postApiAdminDevtoolsBusinessVerificationAttemptsIpAddressClearBody = zod.object({
  "ipAddress": zod.string()
})

export const postApiAdminDevtoolsBusinessVerificationAttemptsIpAddressClearResponse = zod.number()

export const getApiAdminDevtoolsFsmPlatformAccessResponseItem = zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "status": zod.enum(['ComingSoon', 'GenerallyAvailable', 'Private']),
  "isVisible": zod.boolean(),
  "isOverridden": zod.boolean()
})
export const getApiAdminDevtoolsFsmPlatformAccessResponse = zod.array(getApiAdminDevtoolsFsmPlatformAccessResponseItem)

export const putApiAdminDevtoolsFsmPlatformAccessBody = zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isVisible": zod.boolean()
})

export const putApiAdminDevtoolsFsmPlatformAccessResponseItem = zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "status": zod.enum(['ComingSoon', 'GenerallyAvailable', 'Private']),
  "isVisible": zod.boolean(),
  "isOverridden": zod.boolean()
})
export const putApiAdminDevtoolsFsmPlatformAccessResponse = zod.array(putApiAdminDevtoolsFsmPlatformAccessResponseItem)

